// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SOReportAttributes_ListaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Query de GET da lista de atributos de laudo. `incluir_inativos=1` é pedido só pela tela de
 * cadastro; todo o resto recebe apenas os ativos.
 */
import { registerContract } from './validate'

export interface SOReportAttributes_ListaInput {
incluir_inativos?: string
}

registerContract('SOReportAttributes_ListaInput', {
  incluir_inativos: { type: 'string',  required: false },
})
